import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HomeIcon from "@mui/icons-material/Home";
import OrderDetail from "../Order/OrderDetail";
import SearchField from "../mui/SearchField";
import DropdownMenu from "../mui/dropdown";
import CustomDatePicker from "../mui/datePicker";
import { Card, Typography } from "@mui/material";
import { loadAllOrders } from "../data/API";
import { getRegions } from "../data/models/GlobalAdmin";
import ProgressDialog from "../mui/progressdialog";
import AlertDialog from "../mui/dialog";
import { formatDecimalValue } from "../data/Utils";
import CustomDropdownMenu from "../mui/dropdown";

const TITLE_HOME = "Orders";
const TITLE_ORDER_DETAIL = TITLE_HOME + " > Order Detail";

export default function Order() {
  const [menus, setMenus] = React.useState(null);

  const [state, setState] = React.useState(TITLE_HOME);

  const [region, setRegion] = React.useState('');
  const [subRegion, setSubRegion] = React.useState('');

  const [regionsList, setRegionsList] = React.useState([]);
  const [subRegionsList, setSubRegionsList] = React.useState([]);
  const [isWarning, setIsWarning] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const [ordersData, setOrdersData] = React.useState(null);

  const onBackClickListener = () => {
    if (state !== TITLE_HOME) {
      if (state === TITLE_ORDER_DETAIL) {
        setState(TITLE_HOME);
      }
    }
  };

  const onOrderSelection = (order) => {
    console.log(order?.items);
    setMenus(order?.items);
    setState(TITLE_ORDER_DETAIL);
  };

  const OrdersTable = () => {



    function getRegionFromName(n) {
      var region = null;
      console.log(regionsList);
      for (let i = 0; i < regionsList.length; i++) {
        if (n === regionsList[i].name) {
          region = regionsList[i];
        }
      }
      // console.log(region)
      return region;
    }
  
    function getNamesFromRegions(list) {
      return list?.map((data) => {
        return data.name;
      });
    }
  
    function onRegionSelection(selectedNamedRegion) {
      setRegion(selectedNamedRegion);
      var sList = getRegionFromName(selectedNamedRegion).subregions;
  
      setSubRegionsList(sList);
    }
  
    function onSubRegionSelection(selectedNamedSubRegion) {
      setSubRegion(selectedNamedSubRegion);
    }
  
    const [query, setQuery] = React.useState("");
    const [dateRange,setDateRange] = React.useState(null);

    function isDateInRange(dateString, startDateString, endDateString) {
      const date = new Date(dateString);
      const startDate = new Date(startDateString);
      const endDate = new Date(endDateString);
      return date >= startDate && date <= endDate;
    }

    const getFilteredList = (list) => {
      console.log("Zaman:List:", list);
  
      if (
        region === "" ||
        subRegion === "" ||
        region.toLowerCase().includes("entire m")
      ) {
        const newList = [];
  
        list?.forEach((x) => {
          var queryCheck =
            x.kitchen.full_name.toLowerCase().includes(query.toLowerCase()) ||
            x.user.first_name.toLowerCase().includes(query.toLowerCase()) ||
            x.user.email.toLowerCase().includes(query.toLowerCase()) ||
            x.user.last_name.toLowerCase().includes(query.toLowerCase()) ||
            x.details.id.toString().includes(query.toLowerCase()) ||
            query == "";

           var rangeCheck =true;
            if(dateRange!=null){
              rangeCheck = isDateInRange(x.details.order_date,dateRange.startDate,dateRange.endDate);
            }

          if (queryCheck && rangeCheck) {
            newList.push(x);
          }
        });
        return newList;
      } else {
        const newList = [];
  
        list?.forEach((x) => {
         
          var queryCheck =
          x.kitchen.full_name.toLowerCase().includes(query.toLowerCase()) ||
          x.user.first_name.toLowerCase().includes(query.toLowerCase()) ||
          x.user.email.toLowerCase().includes(query.toLowerCase()) ||
          x.user.last_name.toLowerCase().includes(query.toLowerCase()) ||
          x.details.id.toString().includes(query.toLowerCase()) ||
          query == "";
  
          var regionCheck = false;
  
          if (x.kitchen.region.toLowerCase().includes("entire m")) {
            regionCheck = true;
          } else if (
            x.kitchen.region.toLowerCase() == region.toLowerCase() &&
            (x.kitchen.subregion.toLowerCase() == subRegion.toLowerCase() ||
              subRegion.toLowerCase().includes("all " + region.toLowerCase()))
          ) {
            regionCheck = true;
          }


          var rangeCheck =true;
          if(dateRange!=null){
            rangeCheck = isDateInRange(x.details.order_date,dateRange.startDate,dateRange.endDate);
          }

  
          if (queryCheck && regionCheck && rangeCheck) {
            newList.push(x);
          }
        });
        return newList;
      }
    };

    return (
      <div>
        <div
          className="bg-white mx-2 rounded-md "
          style={{
            display: "flex",
            flexDirection: "row",
            marginBlockEnd: "5px",
            alignItems: "center",
          }}
        >
          <CustomDropdownMenu
            onSelection={onRegionSelection}
            width={170}
            label={"Region"}
            value={region}
            list={getNamesFromRegions(regionsList)}
          />
          <CustomDropdownMenu
            onSelection={onSubRegionSelection}
            width={170}
            label={"Sub Region"}
            value={subRegion}
            list={subRegionsList}
          />
          <CustomDatePicker
            onChange={(valObj) => setDateRange(valObj)}
            marginStart={"4px"}
            marginTop={"2px"}
            placeholder={"Click to Select Range"}
          />
          <SearchField setQuery={setQuery} query={query} />
        </div>
        <div>
          <div className="mx-3 my-5" style={{ width: "50%" }}>
            <Card
              fullWidth={false}
              sx={{
                padding: "10px",
                borderRadius: "7px",
                boxShadow: 1,
                display: "flex",
                minWidth: "200px",
              }}
            >
              <div>
                <Typography variant="subtitle1">Transactions</Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "600",
                    color: "green",
                    marginInlineStart: "8px",
                  }}
                >
                  <p
                    style={{ color: "orange", fontSize: "20px" }}
                    className="inline"
                  >
                    nf
                  </p>{" "}
                  {
                    ordersData?.meta?.total_transactions ?? 0
                  }
                </Typography>
              </div>

              <div className="mx-10">
                <Typography variant="subtitle1">Total Sale</Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "600",
                    color: "green",
                    marginInlineStart: "8px",
                  }}
                >
                  {formatDecimalValue(ordersData?.meta?.total_paid ?? 0)}{" "}
                  <p
                    style={{ color: "orange", fontSize: "23px" }}
                    className="inline"
                  >
                    RM
                  </p>
                </Typography>
              </div>
            </Card>
          </div>
        </div>

        <TableContainer sx={{ marginInlineStart: "10px" }} component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "600" }}>ID</TableCell>
                <TableCell style={{ fontWeight: "600" }} align="left">KITCHEN ID</TableCell>
                <TableCell style={{ fontWeight: "600" }} align="left">KITCHEN NAME</TableCell>
                <TableCell style={{ fontWeight: "600" }} align="left">REGION</TableCell>
                <TableCell style={{ fontWeight: "600" }} align="left">SUB REGION</TableCell>
                

                {/* <TableCell align="left">MENU ID</TableCell> */}
                <TableCell style={{ fontWeight: "600" }} align="left">DATE</TableCell>
                <TableCell style={{ fontWeight: "600" }} align="left">TIME</TableCell>
                <TableCell style={{ fontWeight: "600" }} align="left">AMOUNT PAID</TableCell>
                <TableCell style={{ fontWeight: "600" }} align="left">PAYMENT</TableCell>
                <TableCell style={{ fontWeight: "600" }} align="left">STATUS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getFilteredList(ordersData?.orders)?.map((row) => (
                <TableRow
                  onClick={() => onOrderSelection(row)}
                  className="cursor-pointer hover:bg-yellow-200"
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.details.id}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.kitchen.id}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.kitchen.full_name}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.kitchen.region}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.kitchen.subregion}
                  </TableCell>
                  <TableCell align="left">
                    {row.details.created_at.split("T")[0]}
                  </TableCell>
                  <TableCell align="left">
                    {row.details.created_at.split("T")[1].split(".")[0]}
                  </TableCell>
                  <TableCell align="left">
                    {row.details.paid_amount!=null?row.details.paid_amount.substring(0, row.details.paid_amount.length - 2):0 ?? "0"}
                    <p
                      className="inline "
                      style={{
                        fontWeight: "600",
                        color: "green",
                        fontSize: "12px",
                      }}
                    >
                      {" "}
                      RM
                    </p>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.details.is_paid == "true" ? "Paid" : "Not Paid"}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.details.status}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  };

  function loadData() {
    if (ordersData == null) {
      setIsLoading(true);
      setIsWarning(null);
      console.log("called");
      loadAllOrders((err, data) => {
        console.log(data);
        if (err) {
          setIsLoading(false);
          console.log(err);
          setIsWarning(err.toString());
        } else {
          setOrdersData(data);
          getRegions((error2, regions) => {
            if (error2) {
              setIsWarning(error2.toString());
              console.log(error2);
              setIsLoading(false);
              return;
            } else {
              setIsLoading(false);
              setIsWarning(null);
              setRegionsList(regions);
              setSubRegionsList(regions[0].subregions);
            }
          });
        }
      });
    }
  }
  React.useEffect(() => {
    loadData();
  }, []);

  return (
    <div>
      <ProgressDialog msg={"Loading Orders"} visible={isLoading} />
      <AlertDialog
        warningMessage={
          "Something went wrong! please refresh page or connect with internet"
        }
        visible={isWarning}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginBlockEnd: "16px",
        }}
      >
        <div
          style={{
            borderRadius: "10px",
            padding: 8,
            background: "red",
            display: "inline-flex",
            flexDirection: "row",

            boxShadow: "1px 1px 5px 2px rgb(0,0,0,0.2)",
          }}
        >
          <HomeIcon
            onClick={() => {
              setState(TITLE_HOME);
            }}
            sx={{
              color: "white",
              alignSelf: "center",
              marginInlineEnd: 1,
            }}
          />
          {state !== "Orders" ? (
            <ArrowBackIosIcon
              onClick={onBackClickListener}
              sx={{
                color: "white",
                alignSelf: "center",
                marginInlineEnd: 1,
                marginInlineStart: 1,
              }}
            />
          ) : (
            ""
          )}
          <h1
            style={{
              color: "rgb(255, 255, 255)",
              fontSize: 20,
            }}
          >
            {state}
          </h1>
        </div>
      </div>

      <div
        style={{
          height: window.innerHeight - 100,
          overflow: "auto",
        }}
      >
        {state === TITLE_HOME ? (
          <OrdersTable />
        ) : state === TITLE_ORDER_DETAIL ? (
          <OrderDetail
            menus={menus}
            // onOrderSelection={onOrderSelection}
          />
        ) : (
          <p>404 Not Found</p>
        )}
      </div>
    </div>
  );
}
